import React from 'react'
import { useSearchParams, useParams } from 'react-router-dom'
import UserDetail from 'src/containers/UserDetail'

function UserDetailPage() {
	const params = useParams()
	const { id } = params
	const [searchParams] = useSearchParams()
	const returnToFromQuery = searchParams.get('return_to')
	const returnTo = typeof returnToFromQuery === 'string' && returnToFromQuery.startsWith('/')
		? returnToFromQuery
		: '/users'

	return <UserDetail id={id} goBack={returnTo} />
}

export default React.memo(UserDetailPage)
